import styled from "styled-components";

export default styled.div`

////////for ul
.why-accountant-section{
  ul {
    list-style-type: none;
    counter-reset: custom-counter;
    padding-left: 0;
    display: flex;
    flex-direction: column;    
    ${(props) => props.theme.media.lg} {
      display: block;
      flex-direction: column;    
    }
    li {
      font-family: "Poppins";
        color: #505050;
      padding-top: 1rem;
      padding-left: 1.5rem;
      counter-increment: custom-counter;
      position: relative;
      text-align: left;
      font-size: 20px;
      font-weight:500;
    //   font-weight: 500;
      line-height: 1.2;
      max-width: 300px;
      margin: auto;
      &:before {
        content: counter(custom-counter);
        position: absolute;
        display: flex;
        height: 32px;
        width: 32px;
        justify-content: center;
        align-items: center;
        background: #fe6712;
        color: #ffffff;
        font-weight: 500;
        font-size: 21px;
        border-radius: 50%;
        left: 0%;
        transform: translateX(-50%);
        top: 1rem;
      }
    }
  }
  ${(props) => props.theme.media.lg} {
        ul {
          padding-left: 6rem;
          li {
            padding-top: 0;
            position: relative;
            margin-top: 26px;
            text-align: left;
            max-width: none;
            line-height: 1.2;
            font-size: 26px;
            font-weight:500;
            padding-right: 4rem;
            &:before {
              left: -5px;
              top: -4px;
              height: 36px;
              width: 36px;
              font-size: 28px;
              
              transform: translateX(-50%);
            }
          }
        }
  }
}

  //////////// why-accountant-section
  .why-accountant-section {
    background: #f8f6f4;
  }
  //////////////

  .image-mobile-container {
    
    display: flex;
    justify-content: center;
    padding: 0px 15px;

  }

  table {        
    display: flex;
    flex-direction: column;
    justify-content: center;

    .without-border-th {
      border-right: none;
    }

    .without-border-td {
      border-right: none;
    }
    }

    .without-border-bottom {
      border-bottom: none;
    }

    tr {
      display: flex;
      justify-content: space-between;
      th,
      td {
        width: 100%;
        padding: 14px 7px;
        text-align: left;
        ${(props) => props.theme.media.lg} {          
          padding: 14px;
        }
      }

      th {
        background-color: #50646d;
        color: #fff;
        font-weight: normal;
        border-right: 2px solid #fff;
        border-bottom: 2px solid #fff;
      }

      td {
        color: #000;
        font-size: 14px;
        font-weight: 500;
        border-right: 2px solid #fff;
        border-bottom: 2px solid #fff;
      }

      td:nth-child(1) {
        width: 90%;
      }

      td:nth-child(3) {
        width: 90%;
      }

      th:nth-child(1) {
        width: 90%;
      }

      th:nth-child(3) {
        width: 90%;
      }

    }
  }

  .btn.btn-secondary.cta {
    display: block;
    margin-right: auto;
    margin-left: auto;
    font-family: "Inter";
    font-size: 24px;
    padding: 1rem 2rem;
    overflow: hidden;
    font-weight: 300;
    margin-bottom: 2rem;
    max-width: 25rem;

    @media (min-width: 414px) {
      font-size: 30px;
    }

    ${(props) => props.theme.media.md} {
      padding-left: 73px;
      padding-right: 73px;
      width: auto;
      max-width: 30rem;
    }
  }
  .get-started {
    h2 {
      font-size: 28px;
      font-weight: 500;
      max-width: 23rem;
      margin: 0 auto;
      margin-bottom: 32px;
    }

    .bottom-cta {
      display: block;
      font-size: 1.5rem;
      margin: 0 auto;
      margin-bottom: 2rem;
    }

    ${(props) => props.theme.media.md} {
      margin-bottom: 4.4rem;

      h2 {
        font-size: 40px;
        max-width: 37rem;
        margin: 0 auto;
      }

      .bottom-cta {
        font-size: 22px;
      }
    }

    p {
      max-width: 572px;
      margin: auto;
      text-align: center;
      margin-bottom: 30px;
      font-size: 18px;
      color: #626262;
      font-family: "Poppins";
      line-height: 1.5;
    }

    .btn {
    }
  }

  .tax-tips {
    padding-top: 0;
    ${(props) => props.theme.media.md} {
      padding-bottom: 30px;
    }
    h2 {
      font-size: 28px;
      font-weight: 500;
      margin-bottom: 0.5rem;
      text-align: center;
    }

    p {
      font-size: 16px !important;
    }
    .section-subtitle {
      margin-bottom: 1rem;
      text-align: center;
      font-size: 13px;
      line-height: 1.3;
    }

    .product-title {
      text-align: left !important;
    }

    ${(props) => props.theme.media.md} {
      h2 {
        font-size: 40px;
      }
      .section-subtitle {
        margin-bottom: 4rem;
        font-size: 18px;
      }
    }

    .products-wrapper {
      .product {
        > div {
          margin: auto;
        }
        margin-bottom: 0.5rem;
        padding: 0;
        text-align: center;

        ${(props) => props.theme.media.md} {
          margin-bottom: 0;
          padding: 0 30px;
        }

        .product-img {
          margin-bottom: 1.5rem;
          width: 95%;
          ${(props) => props.theme.media.md} {
            width: 100%;
          }
        }

        .copy {
          padding: 0 15px;

          ${(props) => props.theme.media.md} {
            padding: 0;
          }

          .product-title {
            font-size: 20px;
            font-weight: 600;
            line-height: 1.3;
            margin: 1rem 0;
            color: #3f5261 !important;
          }

          .product-description {
            font-size: 13px;
            line-height: 1.2;
            margin: 0 auto;
            text-align: left;
          }

          .text-center {
            color: #fe6600;
            display: block;
            text-align: center;
            margin: 1rem 0;
          }

          ${(props) => props.theme.media.md} {
            .product-title {
              font-size: 20px;
            }
            .product-description {
              font-size: 16px;
              line-height: 1.5;
            }
          }
        }
      }
    }
  }

  .faq-section > section {
    padding-top: 1.75rem;
    ${(props) => props.theme.media.md} {
      padding: 1.6rem 24rem;
    }
  }

  .faq-section {
   .container {
      max-width: 1050px;
  }
    .row .Collapsible{
      width:100%
    }    
  }

  .business-section {
    background: #f8f6f4;

    ${(props) => props.theme.media.xl} {
      max-width: 1305px;
      margin: auto;
    }

    ${(props) => props.theme.media.md} {
      border-radius: 40pt;
    }
  }

  .faq-container {
    h2 {
      font-weight: 600;
      font-size: 36px;

      ${(props) => props.theme.media.md} {
        font-size: 40px;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 0;
        padding-bottom: 2rem;
      }
    }

    .Collapsible {
      text-align: center;
      ${(props) => props.theme.media.lg} {
        text-align: left;
      }
    }

    .Collapsible__contentOuter {
      .Collapsible__contentInner {
        p {
          padding-left: 1rem;
        }
      }
    }

    .Collapsible__trigger {
      font-weight: 500;
      font-size: 1.4rem;
      padding-right: 0;

      ${(props) => props.theme.media.lg} {
        padding-right: 50px;
        display: block;
        font-size: 1.5rem;
      }

      &::after {
        right: 50%;
        top: -23px;
        color: ${(props) => props.theme.secondary};
        font-size: 2rem;
        font-weight: 400;
        transform: translateX(50%);
        ${(props) => props.theme.media.lg} {
          transform: translateX(0);
          right: 0;
          bottom: 0;
          top: unset;
          font-size: 2.5rem;
        }
      }

      &.is-open {
        &::after {
          color: ${(props) => props.theme.secondary};
          transform: rotate(135deg) translate(-44%, -15%);
          font-size: 2rem;

          ${(props) => props.theme.media.lg} {
            transform: rotate(135deg);
          }
        }
      }
    }
  }

  .why-account-wrapper {
    margin-top: 0px;
  }

  .container {
    ${(props) => props.theme.media.lg} {
      max-width: 1486px;
    }
  }
  .service-container {
    ${(props) => props.theme.media.lg} {
      padding: 1rem 0 !important;
      img {
        width: 100%;
        margin: auto;
      }
    }

    .inner {
      display: inline-block;
    }
  }
  .service-image-container {
    width: 40%;    
    ${(props) => props.theme.media.lg} {
      &.image-reverse {
        margin-left: 0rem !important;
      }
    }
  }

  .service-text-container {
    text-align: center;
    width: 100%;
    ${(props) => props.theme.media.lg} {
      width: 60%;
    }
    display: flex;
    justify-content: center;
    .service-title {      
      font-size: 36px !important;      
      margin-left: auto;
      margin-right: auto;
      font-weight: 600 !important;
    }
    p {
      width: 360px;
      margin-left: auto;
      margin-right: auto;
      color: #626262;
    }
    ${(props) => props.theme.media.md} {
      &.text-reverse {
        width: 400px;
        margin-left: 2rem !important;
      }
    }
    ${(props) => props.theme.media.lg} {
      text-align: left;

      p {
        font-size:18px !important;
        display: flex;
        width: 100%;
        padding:0rem 6rem;
      }
      .service-title {
        font-size: 50px !important;
        font-weight: 600 !important;
        line-height: 48px !important;
        margin-left: 0;
        margin-bottom: 1rem !important;
        width: 100%;
        padding:0rem 3rem;
      }
      margin: 0 2rem !important;

      &.text-reverse {
        width: 600px;
        margin-left: 2rem !important;
        width: 60%;

        .service-title {
          padding:0rem 10rem;
        }

      }
    }
    h3 {
      margin-top: 2rem;
    }

    .btn-secondary {
      font-size: 22px;
      background: #f15f22 !important;
      border-color: #f15f22 !important;
      float: none !important;
      margin-top: 1.2rem !important;
      padding: 12px 22px;
    }
  }

  /////////////////////////
  section.tax-preparation {

    .card-body {
      ul {
        margin-bottom: 1rem;
        padding:0px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        ${(props) => props.theme.media.lg} {
          display: block;
        }
      }
      li {
        font-size:15px;
        font-weight: 500;        
        text-align:center;
        ${(props) => props.theme.media.lg} {
          text-align:left;
        }
        margin:0px 0px;
      }
    }

    ${(props) => props.theme.media.lg} {
    //   background-color: #EFE7DA;
    }

    .container {
      max-width: 1400px;

      h2 {
        color: #3F5261;
        font-size: 36px;
        font-weight: 600;
        width: 100%;
        margin-bottom: 10px;
        text-align: center;
        white-space: pre;
        ${(props) => props.theme.media.lg} {
            width: 100%;
            margin-bottom: 2rem;
            font-size: 50px;
            font-weight: 600;
            }
      }

      .taxDescription {
        font-size: 1rem;
        padding: 0;
        ${(props) => props.theme.media.lg} {
          font-size: 1.125rem;
          padding: 0rem 12rem;
          margin-bottom: 40px;
        }        
        font-weight: 400;        
        text-align: center;
        line-height: 1.5;
        margin-bottom: 20px;
      }

      .subtitle {
        margin: 0 auto 2rem;
        text-align: center;
        width: 60%;
      }

      .cards-container {
          font-family: Inter;
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: 1fr;
        padding: 0 2rem;
        margin: auto;
        
        ${(props) => props.theme.media.lg} {
          width: 80%;
          grid-template-columns: repeat(1, 1fr);
          justify-content: space-evenly;
          padding: 0;
        }

        .card {
            box-shadow: 0px 3px 11px #00000029;
            border-radius: 20px;
          margin: auto;
          margin-top: 10px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-auto-rows: auto;
          padding: 1rem;
          
          img {
            margin: 1rem auto;
            height: auto;
            ${(props) => props.theme.media.lg} {
              height: 40px;
            }
            
          }
          .title {
            grid-column-start: 2;
            grid-column-end: end;
            h3 {
              font-family: "Poppins";
              font-size: 1.2rem;
              margin-top: 15px;
              margin-bottm: 5px;
              line-height: 1.2;
              text-align: left;
              font-weight: 500;
            }
          }

          .card-body {
            padding: 0;
            grid-column-start: 1;
            grid-column-end: end;
            ${(props) => props.theme.media.lg} {
              margin: auto;
            }

            ul {              
              ${(props) => props.theme.media.lg} {
                margin-top:-1rem;
                margin-left:20px;
              }
            }

          }
          p {
            font-size: 15px;
            font-weight: 500;
            margin: 0;
            text-align: center;
            line-height: 24px;
            padding: 0;
            ${(props) => props.theme.media.lg} {
              padding: 0 0.6rem;
            }            
          }
          ${(props) => props.theme.media.md} {
            grid-template-columns: 12% [col-start] 45% [col-start] 40% [col-start];
            /*grid-template-rows: [row1-start] 32% [row1-end] auto [third-line];*/
            width: 100%;
            margin: 5px;
            img{
                grid-column-start: 1;
                grid-column-end: 2;
                grid-row-start: 1;
                grid-row-end: 3;
                margin-top: 25px;
                height: 50px;
                width: auto;
            }
            .title{
                grid-column-start: 2;
                grid-column-end: end;
                margin-bottom: 10px;
                padding-bottom: 0;
                h3 {
                    font-size: 20px;
                    // margin-top: 20px;
                    margin-bottm: 0;
                    padding-bottom: 0;
                    line-height: 1.2;
                    text-align: left;
                    font-weight: 500;
                  }
            }
            .card-body{
                grid-column-start: 2;
                grid-column-end: end;
                min-width: 500px; 
                width: 100%;
            }
            p {
                font-size: 15px;
                margin: 0;
                text-align: left;
                line-height: 24px;
                margin-bottom: 1rem;
                padding: 0;
              }
          }
        }
      }
    }
  }

`;
